import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import type { CreateRecurringEntryInput } from '@accounting/shared';
import { useCreateRecurringEntry } from '../../hooks/useRecurring';
import { useActiveCompanyId } from '../../stores/useCompanyStore';
import { RecurringEntryForm } from '../../components/recurring/RecurringEntryForm';
import { ApiError } from '../../lib/api';

export const Route = createFileRoute('/_auth/recurring/new')({
  component: NewRecurringPage,
});

function NewRecurringPage() {
  const companyId = useActiveCompanyId();
  const navigate = useNavigate();
  const create = useCreateRecurringEntry(companyId);

  if (!companyId) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 32 }}>
        <p className="muted">No active company.</p>
        <Link to="/companies" className="btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>Go to Companies</Link>
      </div>
    );
  }

  const errorMessage =
    create.error instanceof ApiError
      ? (create.error.body as { error?: string } | null)?.error ?? 'Could not create recurring entry'
      : create.error?.message;

  const submit = (input: CreateRecurringEntryInput) =>
    create.mutate(input, { onSuccess: (r) => void navigate({ to: '/recurring/$id', params: { id: r.id } }) });

  return (
    <div>
      <Link to="/recurring" style={{ fontSize: 13 }}>← Recurring</Link>
      <h1 style={{ fontSize: 24, margin: '8px 0 16px' }}>New recurring entry</h1>
      <RecurringEntryForm
        companyId={companyId}
        submitLabel="Save template"
        pending={create.isPending}
        errorMessage={errorMessage}
        onSubmit={submit}
      />
    </div>
  );
}
